package com.fireavert.unsubscribe.client.presentation

import com.fireavert.unsubscribe.sever.UnsubscribeSetter

class UnsubscribeController(private val unsubscribeSetter: UnsubscribeSetter) {
    suspend fun unsubscribe(email: String) {
        unsubscribeSetter.set(email)
    }
}